import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSettings } from "../lib/useSettings";
import HeroSlider from "../components/HeroSlider";
import { BreakingFlash } from "../components/SectionParts";
import TrendingGrid from "../components/TrendingGrid";
import ShortNews from "../components/ShortNews";
import VideoNews from "../components/VideoNews";
import LiveTV from "../components/LiveTV";
import Astrology from "../components/Astrology";
import PodcastSection from "../components/PodcastSection";
import Newsletter from "../components/Newsletter";
import CategoryBlock from "../components/CategoryBlock";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [breaking, setBreaking] = useState([]);
  const [trending, setTrending] = useState([]);
  const [shorts, setShorts] = useState([]);
  const [videos, setVideos] = useState([]);
  const [podcasts, setPodcasts] = useState([]);
  const { settings } = useSettings();

  const load = () => Promise.all([
    api.get("/articles", { params: { featured: true, limit: 6 } }),
    api.get("/articles", { params: { breaking: true, limit: 4 } }),
    api.get("/articles", { params: { trending: true, limit: 8 } }),
    api.get("/articles", { params: { short: true, limit: 10 } }),
    api.get("/articles", { params: { video: true, limit: 4 } }),
    api.get("/articles", { params: { category: "podcast", limit: 3 } }),
  ]).then(([f, b, t, s, v, p]) => {
    setFeatured(f.data); setBreaking(b.data); setTrending(t.data);
    setShorts(s.data); setVideos(v.data); setPodcasts(p.data);
  }).catch(() => {});

  useEffect(() => {
    load();
    const interval = (settings?.homepage?.auto_refresh_seconds ?? 60) * 1000;
    if (interval <= 0) return;
    const t = setInterval(load, interval);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [settings?.homepage?.auto_refresh_seconds]);

  return (
    <div className="bodh-world-bg" data-testid="home-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <HeroSlider articles={featured} />
        <BreakingFlash articles={breaking} />
        <TrendingGrid articles={trending} />
        <ShortNews articles={shorts} />
        <VideoNews articles={videos} />
        <CategoryBlock slug="politics" />
        <LiveTV />
        <CategoryBlock slug="business" />
        <CategoryBlock slug="sports" />
        <Astrology />
        <CategoryBlock slug="technology" />
        <PodcastSection articles={podcasts} />
        <CategoryBlock slug="entertainment" />
        <Newsletter />
      </div>
    </div>
  );
}
